export default __webpack_public_path__ + "static/media/easter_high.79403055.png";